import type { EkycStatus } from '@brushfire/types'



/** Short title — avatar/status chip + bell title matching. */
export const EKYC_UNDER_REVIEW_LABEL = 'Your Profile Verification is Under Review'

/** Home / Rewards status card body (under_review). */
export const EKYC_UNDER_REVIEW_BANNER_MESSAGE =
  'Your Profile Verification is Under Review. This process may take 48–72 hours to complete'



export const EKYC_UNDER_REVIEW_BLOCK_MESSAGE =

  'Your profile verification is under review. Survey participation and reward redemption are temporarily unavailable until the review is complete.'



export function isEkycUnderReview(status: EkycStatus | undefined | null): boolean {

  return status === 'under_review'

}



/**

 * First/last name locked while eKYC is under review or approved.

 * Editable again only after rejection (`failed`).

 */

export function areEkycNameFieldsLocked(status: EkycStatus | undefined | null): boolean {

  return status === 'under_review' || status === 'verified'

}



export const EKYC_NAME_FIELDS_LOCKED_MESSAGE =

  'Name locked while verification is in progress or approved. Contact support to update it.'



/** MVP labels: failed / not_started → Unverified; under_review → Figma copy. */

export function ekycStatusLabel(status: EkycStatus | undefined | null): string {

  if (status === 'verified') return 'Verified'

  if (status === 'under_review') return EKYC_UNDER_REVIEW_LABEL

  return 'Unverified'

}



/** Eligible for a new verification session (unfinished abandon/expire still OK). */

export function canStartEkycVerification(profile: {

  ekycRequired?: boolean

  ekycStatus?: string

  ekycAttemptUsed?: boolean

  ekycFailureReason?: string | null

} | null | undefined): boolean {

  if (!profile?.ekycRequired) return false

  if (profile.ekycStatus === 'verified') return false

  if (profile.ekycStatus === 'under_review') return false



  // Unfinished iDenfy outcomes — treat as retryable (typically free).

  if (

    profile.ekycStatus === 'failed' &&

    (profile.ekycFailureReason === 'abandoned' || profile.ekycFailureReason === 'expired')

  ) {

    return true

  }



  return (

    profile.ekycStatus === 'not_started' && profile.ekycAttemptUsed !== true

  )

}



export function shouldShowEkycHomePrompt(profile: {

  ekycRequired?: boolean

  ekycStatus?: string

  ekycAttemptUsed?: boolean

  ekycFailureReason?: string | null

} | null | undefined): boolean {

  return canStartEkycVerification(profile)

}



export const EKYC_HOME_SKIP_SESSION_KEY = 'brushfire_ekyc_home_skip'



export function readEkycHomeSkipped(): boolean {

  if (globalThis.sessionStorage === undefined) return false

  try {

    return globalThis.sessionStorage.getItem(EKYC_HOME_SKIP_SESSION_KEY) === '1'

  } catch {

    return false

  }

}



export function persistEkycHomeSkipped(): void {

  if (globalThis.sessionStorage === undefined) return

  try {

    globalThis.sessionStorage.setItem(EKYC_HOME_SKIP_SESSION_KEY, '1')

  } catch {

    /* private mode */

  }

}



export function clearEkycHomeSkipped(): void {

  if (globalThis.sessionStorage === undefined) return

  try {

    globalThis.sessionStorage.removeItem(EKYC_HOME_SKIP_SESSION_KEY)

  } catch {

    /* private mode */

  }

}


